import React from 'react';

import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';

import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import TagEditContent, { TagEditContentProps } from '../edit/TagEditContent';

type Props = TagEditContentProps & {
    showEditingPopup: boolean;
};

const TagEditPopup = (props: Props) => {
    const { tag, tagElements, showEditingPopup, closePopup, shareRootPath } = props;
    if (!tag) return null;

    return (
        <FloatingPanel
            className="light"
            selector={`#tag-${tag.id}`}
            pollPosition
            offset={20}
            showArrow={false}
            distance={20}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
            show={showEditingPopup}
        >
            <PopupPanelMouseManager visible={showEditingPopup} popupId={PopupIds.TAG_EDIT_MENU} closePopup={() => {}}>
                <TagEditContent
                    tag={tag}
                    tagElements={tagElements}
                    closePopup={closePopup}
                    shareRootPath={shareRootPath}
                />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default TagEditPopup;
